import {
  Component,
  computed,
  effect,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { isEqual } from 'lodash-es';
import { MenuComponent } from '../menu.component';
import { MenuRadioItemInterface } from './menu-radio.interface';

@Component({
  selector: 'shared-ui-menu-radio',
  imports: [MenuComponent],
  templateUrl: './menu-radio.component.html',
  styleUrl: './menu-radio.component.css',
})
export class MenuRadioComponent extends MenuComponent {
  items = input<MenuRadioItemInterface[]>();

  viewItems = computed(() =>
    this.items()?.map((item) => ({
      ...item,
      checked: isEqual(this.value(), item.value),
    })),
  );

  value = model<string | number | (string | number)[]>();

  initialValue = signal<string | number | (string | number)[] | undefined>(
    undefined,
  );

  constructor() {
    super();
    effect(() => {
      if (this.initialValue() === undefined && this.value()) {
        this.initialValue.set(this.value());
      }
    });
  }

  override dialogConfirm = output<
    string | number | (string | number)[] | undefined
  >();

  protected onMenuItemTriggered(dropdownItem: MenuRadioItemInterface): void {
    this.value.set(dropdownItem.value);
  }

  protected onDialogClose(isConfirm: boolean): void {
    if (!isConfirm) {
      this.value.set(this.initialValue());
    }
  }
}
